/* tslint:disable */
/* eslint-disable */
/**
 * Trust Investigation API
 * The Law Society Trust Investigation Api with Swagger, Swashbuckle, and API Versioning.
 *
 * OpenAPI spec version: 2.0
 * Contact: hitesh.patel@lawsociety.com.au
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { AuditTrailViewIEnumerableResponse } from '../models';
import { BooleanResponse } from '../models';
import { IlpDirectorRequest } from '../models';
import { IlpDirectorViewIEnumerableResponse } from '../models';
import { IlpDirectorViewResponse } from '../models';
import { IndividualFirmViewIEnumerableResponse } from '../models';
import { LawIdUserLsApiViewIEnumerableResponse } from '../models';
import { PeopleStatsViewResponse } from '../models';
import { SearchLawIdUsersRequest } from '../models';
import { SignatoryFilterRequest } from '../models';
import { SignatoryRequest } from '../models';
import { SignatoryViewIEnumerableResponse } from '../models';
import { SignatoryViewResponse } from '../models';
/**
 * PeopleApi - axios parameter creator
 * @export
 */
export const PeopleApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary TA All | Delete Signatory
         * @param {number} signatoryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PeopleDeleteSignatorySignatoryIdDelete: async (signatoryId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'signatoryId' is not null or undefined
            if (signatoryId === null || signatoryId === undefined) {
                throw new RequiredError('signatoryId','Required parameter signatoryId was null or undefined when calling apiV2PeopleDeleteSignatorySignatoryIdDelete.');
            }
            const localVarPath = `/api/v2/People/DeleteSignatory/{signatoryId}`
                .replace(`{${"signatoryId"}}`, encodeURIComponent(String(signatoryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TA Admin | Returns ILP Directors By FirmId
         * @param {number} practiceId 
         * @param {string} [keyword] 
         * @param {boolean} [showActiveOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PeopleGetILPDirectorsByPracticeIdPracticeIdGet: async (practiceId: number, keyword?: string, showActiveOnly?: boolean, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'practiceId' is not null or undefined
            if (practiceId === null || practiceId === undefined) {
                throw new RequiredError('practiceId','Required parameter practiceId was null or undefined when calling apiV2PeopleGetILPDirectorsByPracticeIdPracticeIdGet.');
            }
            const localVarPath = `/api/v2/People/GetILPDirectorsByPracticeId/{practiceId}`
                .replace(`{${"practiceId"}}`, encodeURIComponent(String(practiceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }

            if (showActiveOnly !== undefined) {
                localVarQueryParameter['showActiveOnly'] = showActiveOnly;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TA Admin | Returns ILP Director
         * @param {number} ilpDirectorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PeopleGetIlpDirectorByIdIlpDirectorIdGet: async (ilpDirectorId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'ilpDirectorId' is not null or undefined
            if (ilpDirectorId === null || ilpDirectorId === undefined) {
                throw new RequiredError('ilpDirectorId','Required parameter ilpDirectorId was null or undefined when calling apiV2PeopleGetIlpDirectorByIdIlpDirectorIdGet.');
            }
            const localVarPath = `/api/v2/People/GetIlpDirectorById/{ilpDirectorId}`
                .replace(`{${"ilpDirectorId"}}`, encodeURIComponent(String(ilpDirectorId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary All | Returns Individuals By PracticeId
         * @param {number} practiceId 
         * @param {string} [keyword] 
         * @param {boolean} [showActiveOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PeopleGetIndividualsByPracticeIdPracticeIdGet: async (practiceId: number, keyword?: string, showActiveOnly?: boolean, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'practiceId' is not null or undefined
            if (practiceId === null || practiceId === undefined) {
                throw new RequiredError('practiceId','Required parameter practiceId was null or undefined when calling apiV2PeopleGetIndividualsByPracticeIdPracticeIdGet.');
            }
            const localVarPath = `/api/v2/People/GetIndividualsByPracticeId/{practiceId}`
                .replace(`{${"practiceId"}}`, encodeURIComponent(String(practiceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }

            if (showActiveOnly !== undefined) {
                localVarQueryParameter['showActiveOnly'] = showActiveOnly;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary All | Returns People Stats By PracticeId
         * @param {number} practiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PeopleGetPeopleStatsByPracticeIdPracticeIdGet: async (practiceId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'practiceId' is not null or undefined
            if (practiceId === null || practiceId === undefined) {
                throw new RequiredError('practiceId','Required parameter practiceId was null or undefined when calling apiV2PeopleGetPeopleStatsByPracticeIdPracticeIdGet.');
            }
            const localVarPath = `/api/v2/People/GetPeopleStatsByPracticeId/{practiceId}`
                .replace(`{${"practiceId"}}`, encodeURIComponent(String(practiceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary All | Returns Search LawId Users
         * @param {SearchLawIdUsersRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PeopleGetSearchLawIdUsersPost: async (body?: SearchLawIdUsersRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/People/GetSearchLawIdUsers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TA All | Returns Signatories
         * @param {SignatoryFilterRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PeopleGetSignatoriesPost: async (body?: SignatoryFilterRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/People/GetSignatories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TA All | Returns Signatory Audit Trails
         * @param {number} signatoryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PeopleGetSignatoryAuditTrailsSignatoryIdGet: async (signatoryId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'signatoryId' is not null or undefined
            if (signatoryId === null || signatoryId === undefined) {
                throw new RequiredError('signatoryId','Required parameter signatoryId was null or undefined when calling apiV2PeopleGetSignatoryAuditTrailsSignatoryIdGet.');
            }
            const localVarPath = `/api/v2/People/GetSignatoryAuditTrails/{signatoryId}`
                .replace(`{${"signatoryId"}}`, encodeURIComponent(String(signatoryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TA All | Returns Signatory
         * @param {number} signatoryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PeopleGetSignatoryByIdSignatoryIdGet: async (signatoryId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'signatoryId' is not null or undefined
            if (signatoryId === null || signatoryId === undefined) {
                throw new RequiredError('signatoryId','Required parameter signatoryId was null or undefined when calling apiV2PeopleGetSignatoryByIdSignatoryIdGet.');
            }
            const localVarPath = `/api/v2/People/GetSignatoryById/{signatoryId}`
                .replace(`{${"signatoryId"}}`, encodeURIComponent(String(signatoryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TA All | Save ILP Director
         * @param {IlpDirectorRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PeopleSaveIlpDirectorPost: async (body?: IlpDirectorRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/People/SaveIlpDirector`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary TA All | Save Signatory
         * @param {SignatoryRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PeopleSaveSignatoryPost: async (body?: SignatoryRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/People/SaveSignatory`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PeopleApi - functional programming interface
 * @export
 */
export const PeopleApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary TA All | Delete Signatory
         * @param {number} signatoryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2PeopleDeleteSignatorySignatoryIdDelete(signatoryId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await PeopleApiAxiosParamCreator(configuration).apiV2PeopleDeleteSignatorySignatoryIdDelete(signatoryId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TA Admin | Returns ILP Directors By FirmId
         * @param {number} practiceId 
         * @param {string} [keyword] 
         * @param {boolean} [showActiveOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2PeopleGetILPDirectorsByPracticeIdPracticeIdGet(practiceId: number, keyword?: string, showActiveOnly?: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IlpDirectorViewIEnumerableResponse>> {
            const localVarAxiosArgs = await PeopleApiAxiosParamCreator(configuration).apiV2PeopleGetILPDirectorsByPracticeIdPracticeIdGet(practiceId, keyword, showActiveOnly, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TA Admin | Returns ILP Director
         * @param {number} ilpDirectorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2PeopleGetIlpDirectorByIdIlpDirectorIdGet(ilpDirectorId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IlpDirectorViewResponse>> {
            const localVarAxiosArgs = await PeopleApiAxiosParamCreator(configuration).apiV2PeopleGetIlpDirectorByIdIlpDirectorIdGet(ilpDirectorId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary All | Returns Individuals By PracticeId
         * @param {number} practiceId 
         * @param {string} [keyword] 
         * @param {boolean} [showActiveOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2PeopleGetIndividualsByPracticeIdPracticeIdGet(practiceId: number, keyword?: string, showActiveOnly?: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IndividualFirmViewIEnumerableResponse>> {
            const localVarAxiosArgs = await PeopleApiAxiosParamCreator(configuration).apiV2PeopleGetIndividualsByPracticeIdPracticeIdGet(practiceId, keyword, showActiveOnly, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary All | Returns People Stats By PracticeId
         * @param {number} practiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2PeopleGetPeopleStatsByPracticeIdPracticeIdGet(practiceId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PeopleStatsViewResponse>> {
            const localVarAxiosArgs = await PeopleApiAxiosParamCreator(configuration).apiV2PeopleGetPeopleStatsByPracticeIdPracticeIdGet(practiceId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary All | Returns Search LawId Users
         * @param {SearchLawIdUsersRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2PeopleGetSearchLawIdUsersPost(body?: SearchLawIdUsersRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LawIdUserLsApiViewIEnumerableResponse>> {
            const localVarAxiosArgs = await PeopleApiAxiosParamCreator(configuration).apiV2PeopleGetSearchLawIdUsersPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TA All | Returns Signatories
         * @param {SignatoryFilterRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2PeopleGetSignatoriesPost(body?: SignatoryFilterRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SignatoryViewIEnumerableResponse>> {
            const localVarAxiosArgs = await PeopleApiAxiosParamCreator(configuration).apiV2PeopleGetSignatoriesPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TA All | Returns Signatory Audit Trails
         * @param {number} signatoryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2PeopleGetSignatoryAuditTrailsSignatoryIdGet(signatoryId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuditTrailViewIEnumerableResponse>> {
            const localVarAxiosArgs = await PeopleApiAxiosParamCreator(configuration).apiV2PeopleGetSignatoryAuditTrailsSignatoryIdGet(signatoryId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TA All | Returns Signatory
         * @param {number} signatoryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2PeopleGetSignatoryByIdSignatoryIdGet(signatoryId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SignatoryViewResponse>> {
            const localVarAxiosArgs = await PeopleApiAxiosParamCreator(configuration).apiV2PeopleGetSignatoryByIdSignatoryIdGet(signatoryId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TA All | Save ILP Director
         * @param {IlpDirectorRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2PeopleSaveIlpDirectorPost(body?: IlpDirectorRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await PeopleApiAxiosParamCreator(configuration).apiV2PeopleSaveIlpDirectorPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary TA All | Save Signatory
         * @param {SignatoryRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2PeopleSaveSignatoryPost(body?: SignatoryRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await PeopleApiAxiosParamCreator(configuration).apiV2PeopleSaveSignatoryPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * PeopleApi - factory interface
 * @export
 */
export const PeopleApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary TA All | Delete Signatory
         * @param {number} signatoryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PeopleDeleteSignatorySignatoryIdDelete(signatoryId: number, options?: any): AxiosPromise<BooleanResponse> {
            return PeopleApiFp(configuration).apiV2PeopleDeleteSignatorySignatoryIdDelete(signatoryId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TA Admin | Returns ILP Directors By FirmId
         * @param {number} practiceId 
         * @param {string} [keyword] 
         * @param {boolean} [showActiveOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PeopleGetILPDirectorsByPracticeIdPracticeIdGet(practiceId: number, keyword?: string, showActiveOnly?: boolean, options?: any): AxiosPromise<IlpDirectorViewIEnumerableResponse> {
            return PeopleApiFp(configuration).apiV2PeopleGetILPDirectorsByPracticeIdPracticeIdGet(practiceId, keyword, showActiveOnly, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TA Admin | Returns ILP Director
         * @param {number} ilpDirectorId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PeopleGetIlpDirectorByIdIlpDirectorIdGet(ilpDirectorId: number, options?: any): AxiosPromise<IlpDirectorViewResponse> {
            return PeopleApiFp(configuration).apiV2PeopleGetIlpDirectorByIdIlpDirectorIdGet(ilpDirectorId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary All | Returns Individuals By PracticeId
         * @param {number} practiceId 
         * @param {string} [keyword] 
         * @param {boolean} [showActiveOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PeopleGetIndividualsByPracticeIdPracticeIdGet(practiceId: number, keyword?: string, showActiveOnly?: boolean, options?: any): AxiosPromise<IndividualFirmViewIEnumerableResponse> {
            return PeopleApiFp(configuration).apiV2PeopleGetIndividualsByPracticeIdPracticeIdGet(practiceId, keyword, showActiveOnly, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary All | Returns People Stats By PracticeId
         * @param {number} practiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PeopleGetPeopleStatsByPracticeIdPracticeIdGet(practiceId: number, options?: any): AxiosPromise<PeopleStatsViewResponse> {
            return PeopleApiFp(configuration).apiV2PeopleGetPeopleStatsByPracticeIdPracticeIdGet(practiceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary All | Returns Search LawId Users
         * @param {SearchLawIdUsersRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PeopleGetSearchLawIdUsersPost(body?: SearchLawIdUsersRequest, options?: any): AxiosPromise<LawIdUserLsApiViewIEnumerableResponse> {
            return PeopleApiFp(configuration).apiV2PeopleGetSearchLawIdUsersPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TA All | Returns Signatories
         * @param {SignatoryFilterRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PeopleGetSignatoriesPost(body?: SignatoryFilterRequest, options?: any): AxiosPromise<SignatoryViewIEnumerableResponse> {
            return PeopleApiFp(configuration).apiV2PeopleGetSignatoriesPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TA All | Returns Signatory Audit Trails
         * @param {number} signatoryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PeopleGetSignatoryAuditTrailsSignatoryIdGet(signatoryId: number, options?: any): AxiosPromise<AuditTrailViewIEnumerableResponse> {
            return PeopleApiFp(configuration).apiV2PeopleGetSignatoryAuditTrailsSignatoryIdGet(signatoryId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TA All | Returns Signatory
         * @param {number} signatoryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PeopleGetSignatoryByIdSignatoryIdGet(signatoryId: number, options?: any): AxiosPromise<SignatoryViewResponse> {
            return PeopleApiFp(configuration).apiV2PeopleGetSignatoryByIdSignatoryIdGet(signatoryId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TA All | Save ILP Director
         * @param {IlpDirectorRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PeopleSaveIlpDirectorPost(body?: IlpDirectorRequest, options?: any): AxiosPromise<BooleanResponse> {
            return PeopleApiFp(configuration).apiV2PeopleSaveIlpDirectorPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary TA All | Save Signatory
         * @param {SignatoryRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PeopleSaveSignatoryPost(body?: SignatoryRequest, options?: any): AxiosPromise<BooleanResponse> {
            return PeopleApiFp(configuration).apiV2PeopleSaveSignatoryPost(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PeopleApi - object-oriented interface
 * @export
 * @class PeopleApi
 * @extends {BaseAPI}
 */
export class PeopleApi extends BaseAPI {
    /**
     * 
     * @summary TA All | Delete Signatory
     * @param {number} signatoryId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PeopleApi
     */
    public apiV2PeopleDeleteSignatorySignatoryIdDelete(signatoryId: number, options?: any) {
        return PeopleApiFp(this.configuration).apiV2PeopleDeleteSignatorySignatoryIdDelete(signatoryId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TA Admin | Returns ILP Directors By FirmId
     * @param {number} practiceId 
     * @param {string} [keyword] 
     * @param {boolean} [showActiveOnly] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PeopleApi
     */
    public apiV2PeopleGetILPDirectorsByPracticeIdPracticeIdGet(practiceId: number, keyword?: string, showActiveOnly?: boolean, options?: any) {
        return PeopleApiFp(this.configuration).apiV2PeopleGetILPDirectorsByPracticeIdPracticeIdGet(practiceId, keyword, showActiveOnly, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TA Admin | Returns ILP Director
     * @param {number} ilpDirectorId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PeopleApi
     */
    public apiV2PeopleGetIlpDirectorByIdIlpDirectorIdGet(ilpDirectorId: number, options?: any) {
        return PeopleApiFp(this.configuration).apiV2PeopleGetIlpDirectorByIdIlpDirectorIdGet(ilpDirectorId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary All | Returns Individuals By PracticeId
     * @param {number} practiceId 
     * @param {string} [keyword] 
     * @param {boolean} [showActiveOnly] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PeopleApi
     */
    public apiV2PeopleGetIndividualsByPracticeIdPracticeIdGet(practiceId: number, keyword?: string, showActiveOnly?: boolean, options?: any) {
        return PeopleApiFp(this.configuration).apiV2PeopleGetIndividualsByPracticeIdPracticeIdGet(practiceId, keyword, showActiveOnly, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary All | Returns People Stats By PracticeId
     * @param {number} practiceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PeopleApi
     */
    public apiV2PeopleGetPeopleStatsByPracticeIdPracticeIdGet(practiceId: number, options?: any) {
        return PeopleApiFp(this.configuration).apiV2PeopleGetPeopleStatsByPracticeIdPracticeIdGet(practiceId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary All | Returns Search LawId Users
     * @param {SearchLawIdUsersRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PeopleApi
     */
    public apiV2PeopleGetSearchLawIdUsersPost(body?: SearchLawIdUsersRequest, options?: any) {
        return PeopleApiFp(this.configuration).apiV2PeopleGetSearchLawIdUsersPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TA All | Returns Signatories
     * @param {SignatoryFilterRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PeopleApi
     */
    public apiV2PeopleGetSignatoriesPost(body?: SignatoryFilterRequest, options?: any) {
        return PeopleApiFp(this.configuration).apiV2PeopleGetSignatoriesPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TA All | Returns Signatory Audit Trails
     * @param {number} signatoryId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PeopleApi
     */
    public apiV2PeopleGetSignatoryAuditTrailsSignatoryIdGet(signatoryId: number, options?: any) {
        return PeopleApiFp(this.configuration).apiV2PeopleGetSignatoryAuditTrailsSignatoryIdGet(signatoryId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TA All | Returns Signatory
     * @param {number} signatoryId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PeopleApi
     */
    public apiV2PeopleGetSignatoryByIdSignatoryIdGet(signatoryId: number, options?: any) {
        return PeopleApiFp(this.configuration).apiV2PeopleGetSignatoryByIdSignatoryIdGet(signatoryId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TA All | Save ILP Director
     * @param {IlpDirectorRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PeopleApi
     */
    public apiV2PeopleSaveIlpDirectorPost(body?: IlpDirectorRequest, options?: any) {
        return PeopleApiFp(this.configuration).apiV2PeopleSaveIlpDirectorPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary TA All | Save Signatory
     * @param {SignatoryRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PeopleApi
     */
    public apiV2PeopleSaveSignatoryPost(body?: SignatoryRequest, options?: any) {
        return PeopleApiFp(this.configuration).apiV2PeopleSaveSignatoryPost(body, options).then((request) => request(this.axios, this.basePath));
    }
}
